.container {
  display: grid;
  gap: 16px;
}
